import { store } from "../store";
import permission from "../../src/store/modules/permission.js";

const VIEW_PERMISSION = 1;
const EDIT_PERMISSION = 65536;

export default {
  getMenuId(route) {
    if (!route || !route.matched) {
      return undefined;
    }
    const matched = route.matched.filter(f => f.meta && f.meta.menuId !== undefined);
    const item = matched[matched.length - 1];
    return item && item.meta.menuId;
  },
  getPermission(permissions, menuId) {
    if (menuId === undefined || menuId === null) {
      return null;
    }
    return permissions.find(item => String(item.menuId) === String(menuId));
  },
  async getQlwPermissions() {
    const permissionState = store.state.permission;
    if (permissionState && permissionState.qlwPermissions) {
      return permissionState.qlwPermissions;
    }
    return store.dispatch("permission/GetQlwPermissions");
  },
  async checkQlwItem(menuId, permissionValue) {
    const permissions = await this.getQlwPermissions();
    const permission = this.getPermission(permissions, menuId);
    return Boolean(permission && (permission.permissionSumCode & permissionValue) > 0);
  },
  async checkQlwView(menuId) {
    return this.checkQlwItem(menuId, VIEW_PERMISSION);
  },
  async checkItem(menuId, permissionValue) {
    return this.checkQlwItem(menuId, permissionValue);
  },
  async checkEdit(route) {
    const menuId = this.getMenuId(route);
    return Boolean(menuId && (await this.checkQlwItem(menuId, EDIT_PERMISSION)));
  },
  /**
   * 统一页面编辑权限初始化（双版本）
   * @param {object} route - vue-router route
   * @param {object} [options]
   * @param {number|string} [options.permissionId] - 非企联网短权限号
   * @param {object} [options.loginUser] - 默认取 store.state.loginUser
   * @param {boolean|null} [options.isQlwVersion] - 默认取 store.state.curCompany.isQlwVersion
   */
  async initPagePermission(route, options = {}) {
    const loginUser = options.loginUser !== undefined ? options.loginUser : store.state.loginUser;
    const isQlwVersion =
      options.isQlwVersion !== undefined
        ? options.isQlwVersion
        : store.state.curCompany && store.state.curCompany.isQlwVersion;

    if (isQlwVersion === true) {
      return this.checkEdit(route);
    }

    const permissionId = options.permissionId;
    if (
      permissionId === undefined ||
      permissionId === null ||
      !loginUser ||
      !loginUser.permissions
    ) {
      return false;
    }

    const permission = loginUser.permissions.find(
      item => String(item.permissionId) === String(permissionId)
    );
    return Boolean(permission && !permission.isReadOnly);
  }
};
